import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (import.meta.env.VITE_STAGE !== 'production') {
      throw redirect({
        to: '/$companyLocationCode/$siteCode',
        params: { companyLocationCode: 'DEVOFT', siteCode: 'A01' },
      });
    }
  },
  component: Component,
});

function Component() {
  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <h1 className="text-xl font-semibold">Orto-Mate Pay homepage</h1>
    </div>
  );
}
